import React from 'react';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

export default function BannerSectionStyle3({
  bgUrl,
  imgUrl,
  title,
  subTitle,
  btnText,
  btnUrl,
  btnText2,
  btnUrl2,
}) {
  return (
    <section className="relative md:min-h-[520px] flex items-center pt-[116px] pb-14 md:pt-[100px] md:pb-[80px] overflow-hidden bg-cream border-b border-[rgba(139,26,26,0.08)]">
      {/* Subtle background pattern */}
      {bgUrl && (
        <div
          className="absolute inset-0 opacity-[0.04] bg-cover bg-center"
          style={{ backgroundImage: `url(${bgUrl})` }}
        />
      )}

      {/* Decorative left accent line */}
      <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-gradient-to-b from-transparent via-crimson to-transparent opacity-30" />

      <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-16 w-full grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

        {/* Image column (left) */}
        {imgUrl && (
          <div className="hidden md:flex items-end justify-center order-first">
            <img
              src={imgUrl}
              alt="Page banner"
              className="max-h-[380px] w-auto object-contain drop-shadow-xl"
            />
          </div>
        )}

        {/* Text column (right, or full width if no image) */}
        <div className={`flex flex-col justify-center ${!imgUrl ? 'md:col-span-2 max-w-[680px]' : ''}`}>
          <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-4 md:mb-5">
            <span className="w-[30px] h-px bg-gold block" />
            Noohra Integrated Services
          </div>

          <h1 className="font-serif text-[2.25rem] md:text-5xl lg:text-[3.5rem] font-light leading-[1.15] text-charcoal mb-4 md:mb-6">
            {parse(title || '')}
          </h1>

          {subTitle && (
            <p className="text-base leading-[1.8] text-mid font-light max-w-[480px] mb-0">
              {parse(subTitle)}
            </p>
          )}

          {(btnText || btnText2) && (
            <div className="flex flex-wrap gap-x-6 gap-y-4 items-center mt-8">
              {btnText && (
                <Link
                  to={btnUrl || '/appointments'}
                  className="inline-block bg-crimson text-white px-[2.2rem] py-[0.9rem] text-[0.8rem] font-medium tracking-[0.12em] uppercase rounded-sm transition-all duration-250 hover:bg-crimson-dark hover:-translate-y-px hover:shadow-[0_8px_24px_rgba(139,26,26,0.25)]"
                >
                  {btnText}
                </Link>
              )}
              {btnText2 && (
                <Link
                  to={btnUrl2 || '/'}
                  className="inline-flex items-center gap-2 text-crimson text-[0.8rem] font-medium tracking-[0.1em] uppercase border-b border-crimson pb-[2px] transition-all duration-200 hover:gap-3"
                >
                  {btnText2} →
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
